import { createSwiperWithNav, createSwiperWithPagination } from './utils/swiperFactory.js';
import { initScheduleSlider, registerNavPressWatcher } from './utils/scheduleSlider.js';

// DOM読み込み後に初期化（要素の存在を保証）
document.addEventListener('DOMContentLoaded', () => {
    window.swiperScheduleSlider = initScheduleSlider(
    '.schedule-slider',
    '.schedule-slider-next',
    '.schedule-slider-prev',
    {
        // 必要なら上書き（on もマージされます）
        // speed: 1200,
        // breakpoints: { 1280: { slidesPerView: 4 } }
        }
    );
});

// Movie スライド変更時ムービー情報更新
function updateMovieDisplay(swiper) {
  const realIndex = swiper.realIndex;

  const activeSlide = Array.from(swiper.slides).find(slide =>
    parseInt(slide.getAttribute('data-swiper-slide-index')) === realIndex
  );
  if (!activeSlide) return;
  activeSlide.classList.add('slide-movie-active');

  const durSwitch = (swiper.params.speed / 2) / 1000;

  // === メイン画像のクロスフェード切替 ===
  const allImages = document.querySelectorAll('.movie-thumbs-list img');
  const nextImg = Array.from(allImages).find(img =>
    parseInt(img.dataset.index) === realIndex
  );
  const currentImg = document.querySelector('.movie-thumbs-list img.is-active');

  if (nextImg && currentImg && nextImg !== currentImg) {
    nextImg.classList.add('is-active');
    gsap.fromTo(nextImg, { opacity: 0 }, {
      opacity: 1,
      duration: durSwitch,
      ease: 'power0.none'
    });

    gsap.to(currentImg, {
      opacity: 0,
      duration: durSwitch,
      ease: 'power0.none',
      onComplete: () => {
        currentImg.classList.remove('is-active');
      }
    });
  }

  // === タイトル・説明・星の更新 ===
  const titleEl = document.querySelector('.video-info h3');
  const descEl = document.querySelector('.video-info p');
  const ratingWrapper = document.querySelector('.rating-stars');
  const starIcons = Array.from(ratingWrapper.querySelectorAll('li i'));

  const newTitle = activeSlide.getAttribute('data-title');
  const newDesc = activeSlide.getAttribute('data-description');
  const ratingValue = parseFloat(activeSlide.getAttribute('data-rating') || '0');
  const link = document.querySelector('.video-play-btn a');
  if (link) {
    link.href = activeSlide.getAttribute('data-url');
  }

  const tl = gsap.timeline();

  tl.to([titleEl, descEl, ratingWrapper], {
    opacity: 0,
    y: -10,
    duration: durSwitch,
    ease: 'power2.out',
    onComplete: () => {
      titleEl.style.visibility = 'hidden';
      descEl.style.visibility = 'hidden';
      ratingWrapper.style.visibility = 'hidden';

      titleEl.textContent = newTitle;
      descEl.textContent = newDesc;

      // 星の更新
      starIcons.forEach((icon, index) => {
        const score = index + 1;
        let newClass = 'fa-regular fa-star';
        if (ratingValue >= score) {
          newClass = 'fa-solid fa-star full';
        } else if (ratingValue >= score - 0.5) {
          newClass = 'fa-solid fa-star-half-stroke half';
        }
        icon.className = newClass;
      });
    }
  }).to([titleEl, descEl], {
    opacity: 1,
    y: 0,
    duration: durSwitch,
    ease: 'power2.out',
    onStart: () => {
      titleEl.style.visibility = 'visible';
      descEl.style.visibility = 'visible';
    }
  }).add(() => {
    gsap.set(ratingWrapper, {
      opacity: 0,
      x: -20,
      visibility: 'visible'
    });

    gsap.to(ratingWrapper, {
      opacity: 1,
      x: 0,
      duration: durSwitch,
      ease: 'power2.out'
    });
  });
}

// DOM 読み込み時
document.addEventListener('DOMContentLoaded', () => {

  // HERO セクションのスライダー
  window.swiperHeroSlider = createSwiperWithPagination(
    '.hero-slider',
    '.hero-slider-pagination',
    {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      observer: true,
      observeParents: true
    }
  );

  // MOVIE セクションのスライダー
  window.swiperMovieThumbnail = createSwiperWithNav(
    '.movie-slider-area',
    '.movie-slider-next',
    '.movie-slider-prev',
    {
      autoplay: true,
      loop: true,
      watchSlidesProgress: true,
      slidesOffsetBefore: 50,
      slidesOffsetAfter: 50,
      speed: 1500,
      allowTouchMove: true,
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 10,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        }
      },
      on: {
        init: function () {
          updateMovieDisplay(this);
          registerNavPressWatcher(this);
        },
        click: function () {
          if (!this.clickedSlide) return;
          const clickedRealIndex = Number(this.clickedSlide.dataset.swiperSlideIndex);
          // dataset から取得できなかった or 不正な値なら終了
          if (Number.isNaN(clickedRealIndex)) return;
          // すでにアクティブなスライドなら何もしない
          if (clickedRealIndex === this.realIndex) return;
          // 実際にスライド
          this.slideToLoop(clickedRealIndex);
        },
        slideChangeTransitionStart: function () {
          if (this.lastNavBtn) {
            this.lastNavBtn.classList.add('is-swiper-sliding');
          }
          const previousSlide = this.slides[this.previousIndex];
          if (!previousSlide) {
            return;
          }
          previousSlide.classList.remove('slide-movie-active');
        },
        slideChange: function () {
          updateMovieDisplay(this);
        },
        transitionEnd() {
          if (this.lastNavBtn) {
            this.lastNavBtn.classList.remove('is-swiper-sliding');
            this.lastNavBtn = null;
          }
        },
      }
    }
  );

});
